/* bl-herkunft.js — Inhalts-Herkunft für Käufe (Clean Facts + Blog).
 *
 * Wer einen Clean-Facts-Beitrag oder Blogartikel wirklich liest (Lese-Ereignis), wird hier vermerkt:
 *   localStorage  bl_lese = { erst:{typ,handle,datum}, letzt:{typ,handle,datum}, anzahl }
 * Diese Werte hängen 30 Tage lang an jedem Warenkorb als versteckte Attribute (beginnen mit "_",
 * im Checkout unsichtbar, an der Bestellung über die Admin-API lesbar):
 *   _bl_lese_erst   typ|handle|datum
 *   _bl_lese_letzt  typ|handle|datum
 *   _bl_lese_anzahl Zahl gelesener Beiträge
 * Pro Browser-Sitzung wird höchstens einmal nachsynchronisiert, dazu bei jedem neuen Lese-Ereignis.
 * Interner Verkehr: ?bl_intern=1 setzt ein Merkmal, danach senden die bl-Tracking-Skripte keine
 * GA4-Ereignisse mehr (?bl_intern=0 hebt es auf). Die Herkunft wird trotzdem gemerkt (zum Testen).
 */
(function () {
  'use strict';
  if (window.blHerkunft) return;
  var TAGE = 30, KEY = 'bl_lese';
  try {
    var q = new URLSearchParams(location.search).get('bl_intern');
    if (q === '1') localStorage.setItem('bl_intern', '1');
    if (q === '0') localStorage.removeItem('bl_intern');
    window.blIntern = localStorage.getItem('bl_intern') === '1';
  } catch (e) { window.blIntern = false; }

  function heute() { return new Date().toISOString().slice(0, 10); }
  function lesen() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function frisch(d) {
    if (!d || !d.letzt || !d.letzt.datum) return false;
    return (Date.now() - new Date(d.letzt.datum + 'T00:00:00').getTime()) / 864e5 <= TAGE;
  }
  function stempel(t) { return t ? [t.typ, t.handle, t.datum].join('|') : ''; }
  function sync(d) {
    if (!frisch(d)) return;
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: {
          _bl_lese_erst: stempel(d.erst), _bl_lese_letzt: stempel(d.letzt), _bl_lese_anzahl: String(d.anzahl || 1)
        } }),
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }
  var gemerkt = {};
  function merke() {
    var m = location.pathname.match(/\/blogs\/(news|clean-facts)\/([^\/?#]+)/);
    if (!m) return;
    var typ = m[1] === 'news' ? 'blog' : 'cf', handle = m[2];
    if (gemerkt[handle]) return;
    gemerkt[handle] = 1;
    var d = lesen();
    if (!frisch(d)) d = { erst: null, letzt: null, anzahl: 0 };
    var t = { typ: typ, handle: handle, datum: heute() };
    if (!d.erst) d.erst = t;
    d.letzt = t;
    d.anzahl = (d.anzahl || 0) + 1;
    try { localStorage.setItem(KEY, JSON.stringify(d)); sessionStorage.setItem('bl_lese_sync', '1'); } catch (e) {}
    sync(d);
  }
  window.blHerkunft = { merke: merke };
  try {
    if (!sessionStorage.getItem('bl_lese_sync')) {
      var d = lesen();
      if (frisch(d)) { sync(d); sessionStorage.setItem('bl_lese_sync', '1'); }
    }
  } catch (e) {}
})();
